import React from 'react';
import { Users } from 'lucide-react';

const CommunityMembersFab = ({ onClick, memberCount = 0 }) => {
  return (
    <div className="fixed bottom-6 right-6 z-40">
      <button
        type="button"
        onClick={onClick}
        aria-label={`View all members${memberCount ? ` (${memberCount})` : ''}`}
        title="Members"
        className="w-12 h-12 rounded-full shadow-lg flex items-center justify-center transition-all duration-200 bg-red-600 hover:bg-red-700 text-white hover:scale-105"
      >
        <Users className="w-5 h-5" />
      </button>
    </div>
  );
};

export default CommunityMembersFab;
